import React from "react";
import { Box, HStack, Stack } from "@chakra-ui/react";
import { DataToolbar } from "../Toolbar/DataToolbar";
import { FilterBox } from "../Filter/FilterBox";
import FilterPills from "../Filter/FilterPills";

/**
 * Shared page shell for list pages that have a filter sidebar (Explore, Posts, etc.).
 *
 * Props:
 *   hook         — full return value of useFilterPage()
 *   toolbar      — page-specific DataToolbar props (title, type, exportHandler, etc.)
 *   filterBox    — page-specific FilterBox props (explore, showSearch)
 *   middleContent — optional slot between FilterPills and the list (e.g. bulk-delete button)
 *   children     — the <ListView> element
 */
export const FilterPageLayout = ({ hook, toolbar, filterBox = {}, middleContent, children }) => {
  const {
    showFilter, setShowFilter,
    filterPills: filterPillsState,
    filterCount,
    filteredResultCount,
    filterOptions,
    setFilterOptions,
    setSearchText,
    setFilterPills,
    setApply,
    facets,
    searchText,
    handleReset,
    handleCheckboxChange,
    handleSearch,
    handleClear,
    totalRecords,
    currentPage,
    totalPages,
    handlePageChange,
  } = hook;

  return (
    <>
      <Stack
        spacing={0}
        width="100%"
        height="calc(100vh - 120px)"
        mx="auto"
        bg="white"
        p="20px"
        overflow="hidden"
        display="flex"
        flexDirection="column"
      >
        <DataToolbar
          totalRecords={totalRecords}
          handleSearch={handleSearch}
          handleClear={handleClear}
          filterOptions={filterOptions}
          handleCheckboxChange={handleCheckboxChange}
          setApply={setApply}
          currentPage={currentPage}
          totalPages={totalPages}
          handlePageChange={handlePageChange}
          showViewToggle={false}
          showSearch={true}
          onFilterToggle={() => setShowFilter(!showFilter)}
          showFilter={showFilter}
          {...toolbar}
        />

        {((filterPillsState?.search) || filterCount > 0) && (
          <Box px={4} py={2} bg="white" borderBottom="1px solid" borderColor="gray.100">
            <FilterPills
              filters={filterPillsState}
              setFilterOptions={setFilterOptions}
              setApply={setApply}
              setSearchTerm={setSearchText}
              setFilterPills={setFilterPills}
              filteredResultCount={filteredResultCount}
            />
          </Box>
        )}

        {middleContent}

        <HStack flex="1" width="100%" alignItems="flex-start" spacing={0} overflow="hidden">
          <Box flex="1" height="100%" overflow="hidden" display="flex" flexDirection="column" px={4}>
            {children}
          </Box>

          {showFilter && (
            <Stack marginRight="0px!important" right="0px" top="20px" pos="sticky" pt="4">
              <FilterBox
                setApply={setApply}
                setShowFilterBox={setShowFilter}
                handleCheckboxChange={handleCheckboxChange}
                handleSearch={handleSearch}
                filterOptions={filterOptions}
                filteroptionData={facets}
                setFilterOptions={setFilterOptions}
                setSearchTerm={setSearchText}
                filterCount={filterCount}
                searchTerm={searchText}
                handleReset={handleReset}
                className="box-filter-film"
                showSearch={true}
                {...filterBox}
              />
            </Stack>
          )}
        </HStack>
      </Stack>
    </>
  );
};
